import React, { useContext } from 'react';
import { arrayOf, func, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash';
import Collect from '@fiverr-private/collect';
import { setAllCollections } from '../../../../../../../store/collections/actions';
import SharedContext from '../../../../../../../../../shared/context';

import './style.scss';

const { GIG, SELLER } = Collect.RESOURCE_TYPES;

const CollectWrapper = ({ gigId, sellerId, collections = [], setAllCollections = noop }) => {
    const { sourceInfo } = useContext(SharedContext);

    const getResource = () => {
        if (gigId) {
            return { id: gigId.toString(), type: GIG };
        }

        if (sellerId) {
            return { id: sellerId.toString(), type: SELLER };
        }
    };

    const resource = getResource();

    if (!resource) {
        return null;
    }

    return (
        <Collect
            collections={collections}
            resource={getResource()}
            onUpdateCollections={setAllCollections}
            sourceInfo={sourceInfo}
            allowMenuOverflow
            className="collect-seller"
        />
    );
};

CollectWrapper.propTypes = {
    gigId: number,
    sellerId: number,
    collections: arrayOf(object),
    setAllCollections: func,
};

const mapStateToProps = ({ collections }) => ({ collections });

const mapDispatchToProps = {
    setAllCollections,
};

export { CollectWrapper };
export default connect(mapStateToProps, mapDispatchToProps)(CollectWrapper);
